import { render, staticRenderFns } from "./LotProductionRegister.vue?vue&type=template&id=22ed7327"
import script from "./LotProductionRegister.vue?vue&type=script&lang=js"
export * from "./LotProductionRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports